import { useState } from 'react';
import Button from '../../../components/base/Button';

export default function MembershipSection() {
  const [selectedPlan, setSelectedPlan] = useState(1);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [selectedPaymentPlan, setSelectedPaymentPlan] = useState<any>(null);
  const [showCorporateModal, setShowCorporateModal] = useState(false);

  const plans = [
    {
      title: 'Day Pass',
      price: '500',
      period: 'per day',
      description: 'Perfect for trying out our facilities',
      features: [
        'Access to all equipment',
        'Free locker usage',
        'Clean towel service',
        'Free WiFi access',
        'Shower facilities'
      ],
      cta: 'Get Day Pass',
      popular: false
    },
    {
      title: '2 Weeks Trial',
      price: '3,000',
      period: 'per 2 weeks',
      description: 'Perfect for testing your commitment',
      features: [
        'Unlimited gym access for 14 days',
        'All equipment included',
        'Free fitness screening',
        'Professional trainer guidance',
        'Group class access'
      ],
      cta: 'Start Trial',
      popular: false,
      badge: 'Limited Offer'
    },
    {
      title: 'Monthly',
      price: '4,650',
      period: 'per month',
      description: 'Most popular choice for serious fitness',
      features: [
        'Unlimited gym access',
        'All equipment included',
        'Free fitness screening',
        'Professional trainer guidance',
        'Group class access'
      ],
      cta: 'Join Now',
      popular: true,
      badge: 'Most Popular'
    },
    {
      title: 'Semi-Annually',
      price: '25,000',
      period: 'per 6 months',
      description: 'Great value for committed members',
      features: [
        'Unlimited gym access',
        'All equipment included',
        'Free fitness screening',
        'Professional trainer guidance',
        'Group class access',
        'Priority booking'
      ],
      cta: 'Get Started',
      popular: false
    },
    {
      title: 'Annually',
      price: '48,000',
      period: 'per year',
      description: 'Best value for long-term commitment',
      features: [
        'Unlimited gym access',
        'All equipment included',
        'Free fitness screening',
        'Professional trainer guidance',
        'Group class access',
        'Priority booking'
      ],
      cta: 'Best Value',
      popular: false
    },
    {
      title: 'Personal Training + one month membership',
      price: '14,650',
      period: 'per month',
      description: 'One-on-one professional training',
      features: [
        'Dedicated personal trainer',
        'Customized workout plans',
        'Nutrition guidance',
        'Progress tracking',
        'Flexible scheduling',
        'All gym access included'
      ],
      cta: 'Book Now',
      popular: false,
      badge: 'Premium Service'
    }
  ];

  const handlePlanClick = (plan: any, index: number) => {
    setSelectedPlan(index);
    setSelectedPaymentPlan(plan);
    setShowPaymentModal(true);
  };

  const getPesapalUrl = (plan: any) => {
    if (!plan) return 'https://store.pesapal.com/embed-code?pageUrl=https://store.pesapal.com/hfcgympaymentsector';
    const amount = plan.price.replace(/,/g, '');
    return `https://store.pesapal.com/embed-code?pageUrl=https://store.pesapal.com/hfcgympaymentsector&amount=${amount}`;
  };

  const handleMpesaComplete = () => {
    setShowPaymentModal(false);
  };

  return (
    <>
      <section id="membership" className="py-12 lg:py-24 bg-gradient-to-b from-black to-gray-900 relative overflow-hidden">
        {/* Background Elements */}
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-20 -left-20 w-96 h-96 bg-red-600 rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 -right-20 w-96 h-96 bg-red-700 rounded-full blur-3xl"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 lg:px-8">
          {/* Section Header */}
          <div className="text-center mb-6 lg:mb-16">
            <div className="inline-block px-2 py-1 lg:px-4 lg:py-2 bg-red-600/20 border border-red-500/50 text-red-400 rounded-lg text-[10px] lg:text-sm font-bold mb-2 lg:mb-4 uppercase tracking-wider">
              MEMBERSHIP PLANS
            </div>
            <h3 className="text-2xl lg:text-6xl font-black text-white mb-2 lg:mb-6 tracking-tight">
              Start Your <span className="text-red-500">Fitness Journey</span>
            </h3>
            <p className="text-xs lg:text-xl text-gray-400 max-w-3xl mx-auto">
              Choose the plan that fits your schedule. All memberships are non-negotiable and must be paid in FULL
            </p>
          </div>

          {/* Corporate Discount Banner */}
          <div className="mb-6 lg:mb-12 max-w-5xl mx-auto">
            <button
              onClick={() => setShowCorporateModal(true)}
              className="w-full bg-gradient-to-r from-yellow-600/20 via-yellow-500/20 to-yellow-600/20 border-2 border-yellow-500/50 rounded-lg lg:rounded-2xl p-3 lg:p-6 hover:border-yellow-500 transition-all duration-300 hover:scale-[1.02] cursor-pointer"
            >
              <div className="flex items-center justify-between gap-2 lg:gap-4">
                <div className="flex items-center gap-2 lg:gap-4">
                  <div className="w-8 h-8 lg:w-16 lg:h-16 bg-yellow-500/20 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-building-line text-yellow-500 text-base lg:text-3xl"></i>
                  </div>
                  <div>
                    <h4 className="text-xs lg:text-2xl font-black text-yellow-500 mb-0 lg:mb-1 uppercase tracking-wider">
                      CORPORATE DISCOUNT
                    </h4>
                    <p className="text-gray-300 text-[10px] lg:text-sm">
                      Special rates for 15+ members
                    </p>
                  </div>
                </div>
                <div className="hidden md:flex items-center gap-2 px-6 py-3 bg-yellow-500/20 border border-yellow-500/50 rounded-lg">
                  <span className="text-yellow-500 font-bold text-sm uppercase tracking-wider">
                    Learn More
                  </span>
                  <i className="ri-arrow-right-line text-yellow-500"></i>
                </div>
              </div>
            </button>
          </div>

          {/* Pricing Cards */}
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-2 lg:gap-8 max-w-7xl mx-auto">
            {plans.map((plan, index) => (
              <button
                key={index}
                onClick={() => handlePlanClick(plan, index)}
                className={`relative bg-gradient-to-br from-gray-900 via-black to-gray-900 rounded-lg lg:rounded-2xl p-3 lg:p-8 border-2 transition-all duration-300 flex flex-col cursor-pointer text-left w-full ${
                  selectedPlan === index
                    ? 'border-red-600 shadow-[0_0_40px_rgba(220,38,38,0.5)] scale-105'
                    : 'border-gray-800 hover:border-red-500/50'
                } ${plan.popular ? 'lg:col-span-1' : ''}`}
              >
                {/* Popular Badge */}
                {plan.badge && (
                  <div className="absolute -top-2 lg:-top-4 left-1/2 -translate-x-1/2 px-1.5 lg:px-6 py-0.5 lg:py-2 bg-gradient-to-r from-red-600 to-red-700 text-white text-[8px] lg:text-sm font-black rounded-md lg:rounded-lg shadow-lg uppercase tracking-wider whitespace-nowrap">
                    {plan.badge}
                  </div>
                )}

                {/* Header */}
                <div className="text-center mb-2 lg:mb-6 mt-1 lg:mt-0">
                  <h4 className="text-[10px] lg:text-2xl font-black text-white mb-0.5 lg:mb-2 uppercase tracking-wider leading-tight">
                    {plan.title}
                  </h4>
                  <p className="text-gray-400 text-[10px] lg:text-sm hidden lg:block">
                    {plan.description}
                  </p>
                </div>

                {/* Price */}
                <div className="text-center mb-3 lg:mb-8">
                  <div className="flex items-start justify-center mb-0.5 lg:mb-2">
                    <span className="text-[10px] lg:text-2xl text-gray-400 font-bold mt-0.5 lg:mt-2">KES</span>
                    <span className="text-lg lg:text-6xl font-black text-white mx-0.5 lg:mx-2">{plan.price}</span>
                  </div>
                  <p className="text-gray-400 text-[10px] lg:text-sm uppercase tracking-wider">
                    {plan.period}
                  </p>
                </div>

                {/* Features - Hidden on mobile, shown on desktop */}
                <div className="hidden lg:block space-y-4 mb-8 flex-grow">
                  {plan.features.map((feature, idx) => (
                    <div key={idx} className="flex items-start gap-3">
                      <div className="w-5 h-5 rounded-full bg-red-600/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i className="ri-check-line text-red-500 text-xs"></i>
                      </div>
                      <span className="text-gray-300 text-sm leading-relaxed">
                        {feature}
                      </span>
                    </div>
                  ))}
                </div>

                {/* Click to Purchase Text */}
                <div className="mt-auto text-center">
                  <span className="text-red-500 font-bold text-[8px] lg:text-sm uppercase tracking-wider">
                    Tap to Purchase <i className="ri-arrow-right-line ml-0.5"></i>
                  </span>
                </div>
              </button>
            ))}
          </div>

          {/* Important Notes */}
          <div className="mt-6 lg:mt-16 max-w-4xl mx-auto">
            <div className="bg-gray-900/50 border border-red-600/30 rounded-lg lg:rounded-xl p-3 lg:p-8">
              <h4 className="text-white font-black text-xs lg:text-xl mb-2 lg:mb-6 uppercase tracking-wider text-center">
                Terms and Conditions
              </h4>
              <div className="space-y-1.5 lg:space-y-4 text-gray-300 text-[10px] lg:text-sm">
                <div className="flex items-start gap-1.5 lg:gap-3">
                  <i className="ri-information-line text-red-500 text-xs lg:text-lg flex-shrink-0 mt-0.5"></i>
                  <p>All payments are <strong className="text-white">CASHLESS, non-negotiable and must be paid in FULL</strong>.</p>
                </div>
                <div className="flex items-start gap-1.5 lg:gap-3">
                  <i className="ri-close-circle-line text-red-500 text-xs lg:text-lg flex-shrink-0 mt-0.5"></i>
                  <p>Memberships <strong className="text-white">cannot be frozen, carried over, or transferred</strong>.</p>
                </div>
                <div className="hidden lg:flex items-start gap-3">
                  <i className="ri-shield-check-line text-red-500 text-lg flex-shrink-0 mt-0.5"></i>
                  <p>Management reserves <strong className="text-white">right to terminate memberships within reasonable grounds</strong>.</p>
                </div>
                <div className="flex items-start gap-1.5 lg:gap-3">
                  <i className="ri-user-line text-red-500 text-xs lg:text-lg flex-shrink-0 mt-0.5"></i>
                  <p>Members must be <strong className="text-white">at least 14 years old</strong>.</p>
                </div>
                <div className="hidden lg:flex items-start gap-3">
                  <i className="ri-alert-line text-red-500 text-lg flex-shrink-0 mt-0.5"></i>
                  <p>HFC is <strong className="text-white">not responsible for any injuries sustained due to improper use of equipment</strong>.</p>
                </div>
                <div className="hidden lg:flex items-start gap-3">
                  <i className="ri-close-circle-line text-red-500 text-lg flex-shrink-0 mt-0.5"></i>
                  <p>HFC is <strong className="text-white">not responsible for any lost/stolen items</strong>. Bring them at your own risk.</p>
                </div>
                <div className="hidden lg:flex items-start gap-3">
                  <i className="ri-money-dollar-circle-line text-red-500 text-lg flex-shrink-0 mt-0.5"></i>
                  <p>Members are <strong className="text-white">responsible to pay for any damages to items/equipment due to improper use</strong>.</p>
                </div>
                <div className="hidden lg:flex items-start gap-3">
                  <i className="ri-delete-bin-line text-red-500 text-lg flex-shrink-0 mt-0.5"></i>
                  <p>Personal items are <strong className="text-white">not to be left in the premises, they will be stored away, thereafter be disposed of within 24 hours</strong>. HFC will not reimburse or replace the items.</p>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Info */}
          <div className="text-center mt-6 lg:mt-12">
            <p className="text-gray-400 mb-2 lg:mb-4 text-[10px] lg:text-base">
              All memberships include free fitness screening and professional trainer guidance
            </p>
            <div className="flex flex-wrap gap-2 lg:gap-4 justify-center">
              <Button
                href="tel:+254795568891"
                variant="secondary"
                icon="ri-phone-line"
                iconPosition="left"
                className="text-xs lg:text-sm px-3 lg:px-6 py-2 lg:py-3"
              >
                Call to Join
              </Button>
              <Button
                href="https://mail.google.com/mail/?view=cm&fs=1&to=hfckenya@gmail.com"
                target="_blank"
                rel="noopener noreferrer"
                variant="secondary"
                icon="ri-mail-line"
                iconPosition="left"
                className="text-xs lg:text-sm px-3 lg:px-6 py-2 lg:py-3"
              >
                Email Us
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Corporate Discount Modal */}
      {showCorporateModal && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4 animate-fade-in">
          <div className="bg-gradient-to-br from-gray-900 via-black to-gray-900 border-2 border-yellow-500 rounded-2xl max-w-3xl w-full max-h-[90vh] overflow-y-auto shadow-2xl shadow-yellow-500/50 animate-scale-in">
            {/* Header */}
            <div className="sticky top-0 bg-gradient-to-r from-yellow-600 via-yellow-500 to-yellow-600 p-6 border-b-2 border-yellow-500">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                  <div className="w-14 h-14 bg-white/20 rounded-full flex items-center justify-center">
                    <i className="ri-building-line text-white text-3xl"></i>
                  </div>
                  <div>
                    <h3 className="text-3xl font-black text-white mb-1 uppercase tracking-wider">
                      CORPORATE DISCOUNT
                    </h3>
                    <p className="text-yellow-100 text-sm">Exclusive rates for company registrations</p>
                  </div>
                </div>
                <button
                  onClick={() => setShowCorporateModal(false)}
                  className="w-10 h-10 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center transition-all duration-300 cursor-pointer"
                >
                  <i className="ri-close-line text-white text-2xl"></i>
                </button>
              </div>
            </div>

            {/* Content */}
            <div className="p-8">
              <div className="bg-gradient-to-br from-yellow-600/20 to-yellow-700/20 border-2 border-yellow-500/50 rounded-2xl p-8 mb-8 text-center">
                <div className="inline-block px-4 py-2 bg-yellow-500/20 border border-yellow-500/50 rounded-lg text-yellow-400 text-sm font-bold mb-4 uppercase tracking-wider">
                  Special Offer
                </div>
                <h4 className="text-4xl font-black text-white mb-4">
                  Get <span className="text-yellow-500">Exclusive Discount</span> Per Member
                </h4>
                <p className="text-gray-300 text-lg mb-6">
                  When your company registers 15 or more members
                </p>
                <div className="h-px bg-gradient-to-r from-transparent via-yellow-500/50 to-transparent mb-6"></div>
                <div className="bg-yellow-500/10 border border-yellow-500/30 rounded-xl p-6">
                  <p className="text-yellow-400 text-sm mb-2 font-bold">Corporate Rate Available</p>
                  <p className="text-white text-lg">Contact us for special pricing details</p>
                </div>
              </div>

              <div className="mb-8">
                <h4 className="text-white font-black text-2xl mb-6 uppercase tracking-wider text-center">
                  Corporate Membership Benefits
                </h4>
                <div className="grid md:grid-cols-2 gap-4">
                  {[
                    { icon: 'ri-percent-line', title: 'Special Discount', desc: 'Exclusive rates for corporate memberships' },
                    { icon: 'ri-team-line', title: 'Minimum 15 Members', desc: 'Discount applies when registering 15+ employees' },
                    { icon: 'ri-calendar-check-line', title: 'Flexible Scheduling', desc: 'Employees can train at their convenience' },
                    { icon: 'ri-file-list-line', title: 'Easy Billing', desc: 'Single invoice for all corporate members' },
                    { icon: 'ri-heart-pulse-line', title: 'Wellness Programs', desc: 'Access to group fitness classes and workshops' },
                    { icon: 'ri-user-star-line', title: 'Dedicated Support', desc: 'Priority customer service for corporate accounts' },
                  ].map((item, i) => (
                    <div key={i} className="bg-gray-900/50 border border-gray-800 rounded-xl p-5">
                      <div className="flex items-start gap-3">
                        <div className="w-10 h-10 bg-yellow-500/20 rounded-full flex items-center justify-center flex-shrink-0">
                          <i className={`${item.icon} text-yellow-500 text-xl`}></i>
                        </div>
                        <div>
                          <h5 className="text-white font-bold mb-1">{item.title}</h5>
                          <p className="text-gray-400 text-sm">{item.desc}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-4">
                <Button href="tel:+254795568891" variant="cta" icon="ri-phone-line" iconPosition="left" className="flex-1 px-6 py-4">
                  Call Now
                </Button>
                <Button href="https://mail.google.com/mail/?view=cm&fs=1&to=hfckenya@gmail.com" target="_blank" rel="noopener noreferrer" variant="secondary" icon="ri-mail-line" iconPosition="left" className="flex-1 px-6 py-4">
                  Email Us
                </Button>
              </div>

              <div className="mt-6 text-center">
                <p className="text-gray-400 text-xs">
                  * Corporate discount terms and conditions apply. Minimum 15 members required. Contact us for more details.
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* PesaPal Payment Modal */}
      {showPaymentModal && selectedPaymentPlan && (
        <div className="fixed inset-0 bg-black/90 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <div className="bg-gradient-to-br from-gray-900 via-black to-gray-900 border-2 border-red-600 rounded-2xl w-full max-w-2xl shadow-2xl shadow-red-600/40 flex flex-col">
            {/* Header */}
            <div className="bg-gradient-to-r from-red-700 via-red-600 to-red-700 p-4 lg:p-6 rounded-t-2xl border-b-2 border-red-500 flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-secure-payment-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-lg lg:text-2xl font-black text-white uppercase tracking-wider leading-tight">
                    Complete Payment
                  </h3>
                  <p className="text-red-200 text-xs lg:text-sm">
                    {selectedPaymentPlan.title} — <span className="font-bold text-white">KES {selectedPaymentPlan.price}</span>
                  </p>
                </div>
              </div>
              <button
                onClick={() => setShowPaymentModal(false)}
                className="w-9 h-9 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center transition-all duration-300 cursor-pointer flex-shrink-0"
              >
                <i className="ri-close-line text-white text-xl"></i>
              </button>
            </div>

            {/* PesaPal iframe */}
            <div className="flex-1 flex flex-col items-center justify-center p-4 lg:p-6">
              <p className="text-gray-400 text-xs lg:text-sm text-center mb-4">
                Secure payment powered by PesaPal. Your selected amount has been pre-filled below.
              </p>
              <div className="w-full rounded-xl overflow-hidden border border-red-600/30 bg-white" style={{ minHeight: '520px' }}>
                <iframe
                  src={getPesapalUrl(selectedPaymentPlan)}
                  width="100%"
                  height="520"
                  frameBorder="0"
                  allowFullScreen
                  title="PesaPal Payment"
                  className="w-full block"
                  style={{ minHeight: '520px' }}
                />
              </div>
              <p className="text-gray-500 text-xs text-center mt-3">
                <i className="ri-lock-line mr-1 text-red-500"></i>
                All transactions are encrypted and secure
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
